<template>
    <div v-if="loaded" class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="success" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
            <NevsButton class="primary" @click="acceptClick()"><i class="fa-solid fa-user-check"></i>
                {{ $LANG.Get('buttons.acceptRegistration') }}
            </NevsButton>&nbsp;
            <NevsButton class="error" @click="backClick"><i class="fa-solid fa-arrow-left"></i>
                {{ $LANG.Get('buttons.back') }}
            </NevsButton>
        </div>

        <NevsCard class="form">
            <NevsTextField v-model="registration.first_name" :error="validation.first_name"
                           :label="'*' + $LANG.Get('fields.firstName') + ':'"></NevsTextField>
            <NevsTextField v-model="registration.last_name" :error="validation.last_name"
                           :label="'*' + $LANG.Get('fields.lastName') + ':'"></NevsTextField>
            <NevsTextField v-model="registration.oib" :error="validation.oib"
                           :label="$LANG.Get('fields.oib') + ':'"></NevsTextField>
            <NevsCheckbox v-model="registration.foreign" :label="$LANG.Get('fields.foreignClient')"></NevsCheckbox>
            <NevsSelect :nullable="true" v-model="registration.gender_id" :ajax="'select/genders'"
                        :label="$LANG.Get('fields.gender') + ':'"></NevsSelect>
            <NevsDateField v-model="registration.date_of_birth" :label="$LANG.Get('fields.dateOfBirth') + ':'"></NevsDateField>
            <NevsTextField v-model="registration.email" :error="validation.email"
                           :label="$LANG.Get('fields.email') + ':'"></NevsTextField>
            <NevsTextField v-model="registration.phone" :label="$LANG.Get('fields.phone') + ':'"></NevsTextField>
            <NevsTextField v-model="registration.address" :label="$LANG.Get('fields.address') + ':'"></NevsTextField>
            <NevsTextField v-model="registration.postal_code" :label="$LANG.Get('fields.postalCode') + ':'"></NevsTextField>
            <NevsTextField v-model="registration.city" :label="$LANG.Get('fields.city') + ':'"></NevsTextField>
            <NevsTextField v-model="registration.country" :label="$LANG.Get('fields.country') + ':'"></NevsTextField>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";

export default {
    name: "EntityRegistration",
    components: {NevsCheckbox, NevsDateField, NevsSelect, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            loaded: false,
            registration: {
                id: 0,
                first_name: '',
                last_name: '',
                oib: '',
                foreign: false,
                gender_id: null,
                date_of_birth: null,
                email: '',
                phone: '',
                address: '',
                postal_code: '',
                city: '',
                country: ''
            },
            validation: {
                first_name: '',
                last_name: '',
                oib: '',
                email: ''
            }
        }
    },
    methods: {
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        validate() {
            let valid = true;
            if (this.registration.first_name.trim() === '') {
                this.validation.first_name = this.$LANG.Get('labels.mandatoryField');
                valid = false;
            } else {
                this.validation.first_name = '';
            }
            if (this.registration.last_name.trim() === '') {
                this.validation.last_name = this.$LANG.Get('labels.mandatoryField');
                valid = false;
            } else {
                this.validation.last_name = '';
            }
            let oib = (this.registration.oib || '').trim();
            // A foreigner's identification number is not an OIB, so its format is not checked.
            if (oib !== '' && !this.registration.foreign && !this.$HELPERS.CheckOIB(oib)) {
                this.validation.oib = this.$LANG.Get('labels.invalidOIB');
                valid = false;
            } else {
                this.validation.oib = '';
            }
            let email = (this.registration.email || '').trim();
            if (email !== '' && !this.$HELPERS.CheckEmail(email)) {
                this.validation.email = this.$LANG.Get('labels.invalidEmailAddress');
                valid = false;
            } else {
                this.validation.email = '';
            }
            return valid;
        },
        saveClick(callback) {
            if (!this.validate()) {
                return;
            }
            let vm = this;
            this.$API.APICall('put', 'registrations/' + this.registration.id, this.registration, (data, success) => {
                if (success) {
                    vm.$LOCAL_BUS.TriggerEvent('notification', {text: vm.$LANG.Get('alerts.recordSaved')});
                    if (typeof callback === 'function') {
                        callback();
                    }
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        acceptClick() {
            if (!this.validate()) {
                return;
            }
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.acceptRegistrationQuestion'), callback: (response) => {
                    if (!response) {
                        return;
                    }
                    // Persist any edits first, then accept so the created person reflects the current form.
                    vm.saveClick(() => {
                        vm.$API.APICall('post', 'registrations/accept/' + vm.registration.id, {}, (data, success) => {
                            if (success) {
                                vm.$LOCAL_BUS.TriggerEvent('notification', {text: vm.$LANG.Get('alerts.registrationAccepted')});
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-persons', {});
                                vm.backClick();
                            } else if (data.error === 'oib_duplicate') {
                                vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.oibDuplicate'), type: 'alert'});
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    });
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'clients');
        this.$store.commit('selectSubMenu', 'registrations');

        let vm = this;
        this.$API.APICall('get', 'registrations/' + this.$route.params.id, {}, (data, success) => {
            if (success && data.registration !== null) {
                vm.registration = JSON.parse(JSON.stringify(data.registration));
                vm.$store.commit('setBreadcrumbs', [
                    {label: vm.$LANG.Get('modules.clients'), link: null},
                    {label: vm.$LANG.Get('modules.registrations'), link: '/registrations'},
                    {label: vm.registration.first_name + ' ' + vm.registration.last_name, link: null}
                ]);
                vm.loaded = true;
            } else {
                vm.$HELPERS.HandleServerError(vm, data);
            }
        });
    }
}
</script>

<style scoped>
.form {
    max-width: 600px;
    margin-bottom: 10px;
    padding: 15px;
}
</style>
